import React from 'react';

import AssetInventoryV2Container from '@totem/components/services/assetInventory/v2/AssetInventoryV2Container';
import AssetInventoryV2Layout, {
  AssetInventoryV2Scope,
} from '@totem/components/services/assetInventory/v2/AssetInventoryV2Layout';
import { assetInventoryV2Configuration } from '@totem/components/services/assetInventory/v2/configuration';
import IBCard from '@totem/components/ui_components/antDesignOverrides/IBCard';
import ContentLayout from '@totem/components/ui_components/page/ContentLayout';
import InputContainer from '@totem/components/ui_components/reportSettings/InputContainer';

const AssetInventoryV2Page = () => (
  <ContentLayout>
    <InputContainer
      componentKey={'dashboard.asset-inventory-v2'}
      componentLabel={'Services: Asset Inventory (v2)'}
      filterConfig={assetInventoryV2Configuration}
      useUrlParams
      defaultSort={{
        field: 'name',
        direction: 'ascend',
      }}
      staticFilters={[{ field: 'isMonitored', values: ['ACTIVE'] }]}
    >
      <AssetInventoryV2Container>
        <IBCard
          isCovered
          title="Asset Inventory"
          extra={<AssetInventoryV2Scope />}
        >
          <AssetInventoryV2Layout />
        </IBCard>
      </AssetInventoryV2Container>
    </InputContainer>
  </ContentLayout>
);

export default AssetInventoryV2Page;
